export default function Footer() {
  return (
    <footer>
      <div className="container">

        <div className="footer-content">

          <div className="footer-column">
            <h3>Ideas On Work</h3>
            <p>
              Digital transformation specialists for {/* Palghar-Boisar  */}industrial businesses.
            </p>
          </div>

          <div className="footer-column">
            <h3>Solutions</h3>
            <ul className="footer-links">
              <li>Website Development</li>
              <li>Business Email</li>
              <li>AI Chatbots</li>
              <li>CRM Solutions</li>
              {/* <li><a href="#">Website Development</a></li>
              <li><a href="#">Business Email</a></li>
              <li><a href="#">AI Chatbots</a></li>
              <li><a href="#">CRM Solutions</a></li> */}
            </ul>
          </div>

          <div className="footer-column">
            <h3>Contact</h3>
            <ul className="footer-links">
              <li>Email: hello@ideasonwork.in</li>
              <li>Phone: +91 92092 64479</li>
              <li>Based at Nagpur</li>
              {/* <li>Serving Palghar-Boisar</li> */}
            </ul>
          </div>

        </div>

        <div className="copyright">
          <p>© 2026 Ideas On Work. All rights reserved.</p>
        </div>

      </div>
    </footer>
  );
}
